// *******************************************************
// AppleCartIcon
// -------------------------------------------------------
// Component Description
//
// Link to icon:
//
// -------------------------------------------
// *******************************************
// Module Imports
// -------------------------------------------
import React, { ReactElement } from 'react';

// *******************************************
// Interface Imports
// -------------------------------------------
import IIconProp from '../../../iconInterface';

// *******************************************
// Main Component
// -------------------------------------------
export const AppleCartIcon = ({
  className = 'h-full w-auto',
  fillColor = '#000',
}: IIconProp): ReactElement => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Apple cart</title>
      <defs>
        <path
          d="M12.4296875,7.49982598 L18.6714844,7.49982598 C18.8769531,5.9580291 18.4703125,3.49006035 16.5691406,3.1486541 C15.8609375,3.03029473 14.5417969,3.39006035 13.7375,3.83966973 C13.0730469,3.46779473 12.0792969,3.17638848 11.3488281,3.14474785 C11.4199219,3.23107598 11.4984375,3.30763848 11.5636719,3.4017791 C12.3777344,4.57951348 12.5691406,6.22599785 12.4296875,7.49982598 L12.4296875,7.49982598 Z M8.22382812,1.97131035 C8.66484375,1.49513848 8.7875,0.720138479 8.74023438,0.0095916042 C8.23710937,-0.0240021458 7.346875,0.0049041042 6.78632812,0.528341604 C6.140625,1.1767791 6.2484375,2.3392791 6.26992187,2.49006035 C6.99140625,2.53810723 7.7453125,2.41779473 8.22382812,1.97131035 Z M15.7117187,1.97131035 C16.1527344,1.49513848 16.2753906,0.720138479 16.228125,0.0095916042 C15.725,-0.0240021458 14.8347656,0.0049041042 14.2742188,0.528341604 C13.6285156,1.1767791 13.7363281,2.3392791 13.7578125,2.49006035 C14.4792969,2.53810723 15.2332031,2.41779473 15.7117187,1.97131035 Z M11.1835938,7.49982598 C11.3890625,5.9580291 10.9824219,3.49006035 9.08125,3.1486541 C8.37304688,3.03029473 7.05390625,3.39006035 6.25,3.83966973 C5.44296875,3.38810723 4.12382812,3.03068535 3.41875,3.1486541 C1.51992187,3.48966973 1.11445313,5.97170098 1.31640625,7.49982598 L11.1835938,7.49982598 Z M19.375,8.74982598 L0.625,8.74982598 C0.2796875,8.74982598 0,9.02951348 0,9.37482598 L0,13.749826 L20,13.749826 L20,9.37482598 C20,9.02951348 19.7203125,8.74982598 19.375,8.74982598 Z M2.5,11.874826 C2.1546875,11.874826 1.875,11.5951385 1.875,11.249826 C1.875,10.9045135 2.1546875,10.624826 2.5,10.624826 C2.8453125,10.624826 3.125,10.9045135 3.125,11.249826 C3.125,11.5951385 2.8453125,11.874826 2.5,11.874826 Z M17.5,11.874826 C17.1546875,11.874826 16.875,11.5951385 16.875,11.249826 C16.875,10.9045135 17.1546875,10.624826 17.5,10.624826 C17.8453125,10.624826 18.125,10.9045135 18.125,11.249826 C18.125,11.5951385 17.8453125,11.874826 17.5,11.874826 Z M0,19.374826 C0,19.7201385 0.2796875,19.999826 0.625,19.999826 L19.375,19.999826 C19.7203125,19.999826 20,19.7201385 20,19.374826 L20,14.999826 L0,14.999826 L0,19.374826 Z M17.5,16.874826 C17.8453125,16.874826 18.125,17.1545135 18.125,17.499826 C18.125,17.8451385 17.8453125,18.124826 17.5,18.124826 C17.1546875,18.124826 16.875,17.8451385 16.875,17.499826 C16.875,17.1545135 17.1546875,16.874826 17.5,16.874826 Z M2.5,16.874826 C2.8453125,16.874826 3.125,17.1545135 3.125,17.499826 C3.125,17.8451385 2.8453125,18.124826 2.5,18.124826 C2.1546875,18.124826 1.875,17.8451385 1.875,17.499826 C1.875,17.1545135 2.1546875,16.874826 2.5,16.874826 Z"
          id="path-1-apple-cart-pakf"
        ></path>
      </defs>
      <g
        id="00-Micronaires/Icons/Apple-create"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Colours/Black-#000000-apple-cart-pakf"
          transform="translate(2.000000, 2.000000)"
        >
          <mask id="mask-2-apple-cart-pakf" fill="white">
            <use xlinkHref="#path-1-apple-cart-pakf"></use>
          </mask>
          <use
            id="Mask-apple-cart-pakf"
            fill={fillColor}
            fillRule="nonzero"
            xlinkHref="#path-1-apple-cart-pakf"
          ></use>
          <g id="Group-apple-cart-pakf" mask="url(#mask-2-apple-cart-pakf)">
            <g transform="translate(-12.000000, -12.000000)">
              <rect
                id="Rectangle-apple-cart-pakf"
                fill={fillColor}
                x="0"
                y="0"
                className={className}
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AppleCartIcon;
